import styled, { css } from 'styled-components';

const imageWidth = {
  'xxsmall': 16,
  'xsmall': 32,
  'small': 46,
  'medium': 72,
  'large': 96
};

const getWidth = props => {
  const imageSize = `${imageWidth[props.size]}px !important`;
  return css`
    height: ${imageSize};
    width: ${imageSize};
  `;
};

const StyledSpinner = styled.div`
  & svg {
    transform: translate(-25%) !important;
    ${props => getWidth(props)};
  }

  /* The animation engine is loaded on demand (H1MVP-4742), so for a moment on first load this
     container holds nothing and would collapse to zero height, shifting whatever sits below it.
     Scoped to :empty so it stops applying the instant the SVG is attached. */
  & > div:empty {
    ${props => getWidth(props)};
  }
`;

export { StyledSpinner };
